export default __webpack_public_path__ + "static/media/frame.c4338d0f.png";